import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { auth, postAuthPath } from "@/lib/api";
import { useAuth } from "@/lib/auth-context";

export default function AuthCallback() {
  const loc = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    (async () => {
      const hash = loc.hash || "";
      const m = hash.match(/session_id=([^&]+)/);
      if (!m) { nav("/login"); return; }
      try {
        const u = await auth.googleSession(m[1]);
        setUser(u);
        window.history.replaceState({}, document.title, "/app");
        nav(postAuthPath(), { replace: true });
      } catch { nav("/login"); }
    })();
  }, [loc.hash, nav, setUser]);

  return <div className="min-h-screen flex items-center justify-center bg-primary text-white font-display">
    <div className="eyebrow text-accent">Securing session…</div>
  </div>;
}
